export default "__VITE_ASSET__DLeOFgkM__"